import { Component, Input, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
declare var $: any;

@Component({
    selector: 'ups-fileUpload',
    template: require('./ups-fileUpload.component.html'),
    styles: [require('./ups-fileUpload.component.css')]
})
export class UpsFileUploadComponent implements OnInit {

    public fileList: Array<any> = [];
    //private invalidFiles: any = [];
    @Input() private maxFileSize: number = 0;
    @Input() private titleBtnRemove: string = '';
    @Input() private validFileTypes: Array<string> = [];
    @Input() private numberFiles: number = 0;
    @Input() private getFileList: Array<any> = [];
    @ViewChild('inputFile', { static: false }) inputFile: any;
    @Output() private filesChange: EventEmitter<FilesList> = new EventEmitter();
    @Output() private errorType: EventEmitter<string> = new EventEmitter();
    progressValue: any = [];
    public visbleAddFoto: boolean = true;
    public visbleAddFotoName: boolean = false;


    ngOnInit() {

        if (this.numberFiles === 1) {
            if (this.getFileList.length === 1) {
                this.fileList = this.getFileList;
                this.visbleAddFoto = false;
                this.visbleAddFotoName = true;
            }

        }

    }

    public triggerFileInput(): void {
        let fileInput = document.getElementById('inputFile');
        fileInput.click();
    }

    public onFileInput(event) {
        let files;
        try {
            files = event.srcElement.files;
        }
        catch (exception) {
            files = event.target.files;
        }


        if (this.numberFiles === 1) {
            this.visbleAddFoto = false;
            this.visbleAddFotoName = true;
        }
        else {
            if (this.numberFiles !== 0 && this.numberFiles <= this.fileList.length) {
                this.inputFile.nativeElement.value = "";
                return;
            }
        }

        var validFile = [];
        if (files.length > 0) {
            for (let f of files) {
                if (this.validFileTypes.indexOf(f.type) !== -1) {
                    let durationValue: number;
                    if (this.maxFileSize !== 0 && f.size > this.maxFileSize) {
                        if (this.fileList.length === 0) {
                            this.visbleAddFoto = true;
                            this.visbleAddFotoName = false;
                        } else {
                            this.visbleAddFoto = false;
                            this.visbleAddFotoName = true;
                        }
                        if (this.numberFiles !== 1) {
                            this.inputFile.nativeElement.value = "";
                        }
                        this.errorType.emit('errorFileMax');
                        console.log('errorFileMax');
                        return;
                    } else {
                        this.errorType.emit('successFileMax');
                    }
                    this.errorType.emit('succesType');

                    if (this.numberFiles === 1) {
                        this.fileList = [];
                    }
                    //for (var i = 10; i < 100; i += 10) {
                    //    let obj = Object();
                    //    obj.progress = i;
                    //    this.progressValue.push(obj);
                    //}

                    let fl: File = files[0];
                    let file = {
                        file: f,
                        fileName: f.name,
                        fileContent: "",
                        filesEvent: fl,
                        uploadDuration: durationValue,
                        uploadTrigger: true
                    };
                    this.fileList.push(file);
                    let objfilesList: FilesList = new FilesList();
                    objfilesList.file = this.fileList;
                    objfilesList.status = 'add';
                    this.filesChange.emit(objfilesList);



                } else {
                    if (this.fileList.length === 0) {
                        this.visbleAddFoto = true;
                        this.visbleAddFotoName = false;
                    } else {
                        this.visbleAddFoto = false;
                        this.visbleAddFotoName = true;
                    }
                    this.errorType.emit('error');
                    console.log('error type');

                }
                if (this.numberFiles !== 1) {
                    this.inputFile.nativeElement.value = "";
                }
            }
        }
    }

    public deleteFile(file: any, index: number): void {
        this.visbleAddFotoName = false;
        this.visbleAddFoto = true;
        this.inputFile.nativeElement.value = "";
        this.fileList.splice(index, 1);
        let objfilesList: FilesList = new FilesList();
        objfilesList.file = this.fileList;
        objfilesList.status = 'delete';
        this.filesChange.emit(objfilesList);
    }

    public clear() {
        this.fileList = [];
        if (this.numberFiles === 1) {
            this.visbleAddFoto = true;
        }  
    }

    public load(list: any) { 
        this.fileList = list;
    }

}

export class FilesList {
    file: File[];
    status: string;
}
